import { FormValues } from "../types";

/**
 * Monta o simulation_data salvo no histórico (simulator-invoice). O conteúdo
 * do CSV de medição é grande (~720 linhas) e não é persistido —
 * medicaoCsvFileName permanece como indicador de que a simulação era modo CSV.
 */
export function buildSimulationHistoryData(
  values: FormValues
): Omit<FormValues, "medicaoCsv"> & { simulation_date: Date } {
  const { medicaoCsv, ...rest } = values;
  return { ...rest, simulation_date: new Date() };
}
